import { DriveListResponse } from '@dto/drive';
import { BASE_URL } from './constants';
import { get } from './utils';

export function listDriveItems(wsKey: string, path: string): Promise<DriveListResponse | null | any> {
    const url = `${BASE_URL}/data/drive/${wsKey}?path=${encodeURIComponent(path)}`;
    return get<DriveListResponse>(url);
}

export function downloadDriveFile(wsKey: string, filePath: string): void {
    const url = `${BASE_URL}/data/drive/${wsKey}/download?path=${encodeURIComponent(filePath)}`;
    const a = document.createElement('a');
    a.href = url;
    a.download = filePath.split('/').pop() ?? 'download';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export function parentPath(currentPath: string): string {
    const trimmed = currentPath.replace(/\/$/, '');
    const idx = trimmed.lastIndexOf('/');
    if (idx <= 0) return '';
    return trimmed.slice(0, idx + 1);
}
